import { IFullPlanDetailPPO } from "../../../interfaces/api";
import { getDoubleDeepPPO } from "../../../functions/planDetails";
import PPODoubleDeepInfoBenefit from "./PPODoubleDeepInfoBenefit.component";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const PPODataTableSSCBI = ({ data }: { data: IFullPlanDetailPPO }) => {
  const { selectedYear } = useZipRootLoaderData();
  const groceries = getDoubleDeepPPO(
    data,
    "SSBCI",
    selectedYear === 2024
      ? "Groceries Benefit (SSBCI)"
      : "Special Supplemental Benefits for the Chronically Ill (SSBCI) Groceries Benefit"
  );
  const petservice = getDoubleDeepPPO(data, "SSBCI", "Pet Services (SSBCI)");
  const pestcontrol = getDoubleDeepPPO(data, "SSBCI", "Pest Control (SSBCI)");

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",

        textAlign: "left",
      }}
    >
      <div
        className="grid-x hide-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        {" "}
        <div
          className="cell small-12 hide-for-small-only"
          style={{
            fontSize: "18px",
            fontWeight: 400,
            paddingBottom: 20,
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          Qualifying chronic conditions include: congestive heart failure,
          chronic obstructive pulminary disease, dementia, diabetes, and stroke.
          Other chronic conditions may apply.
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        ></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
            paddingTop: 10,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: 20,
            paddingTop: 10,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div className="cell small-4"></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <PPODoubleDeepInfoBenefit benefit={groceries} title="Groceries" />
      <PPODoubleDeepInfoBenefit benefit={petservice} title="Pet Services" />
      <PPODoubleDeepInfoBenefit benefit={pestcontrol} title="Pest Control" />
    </div>
  );
};

export default PPODataTableSSCBI;
